import { Action, combineReducers, Reducer } from "redux";
import { createReducer, PayloadAction } from "typesafe-actions";
import { ChatFolderData } from "@sms/shared/chat/chat-folder.interface";

import {
  createChatFoldersAction,
  selectChangeFolderAction,
  setChatFoldersAction,
  setCurrentFolderAction,
  setSelectChatFoldersAction
} from "./folders.actions";

export interface ChatFoldersStore {
  folders: ChatFolderData[];
  currentFolder: ChatFolderData | null;
  createChatFolder: ChatFolderData;
  changeChatFolder: ChatFolderData;
  selectChatFolders: ChatFolderData[];
}

export const chatFoldersReducer: Reducer<ChatFoldersStore> = combineReducers({
  folders: createReducer<ChatFolderData[], Action>([]).handleAction(
    setChatFoldersAction,
    (_: ChatFolderData[], { payload }: PayloadAction<string, ChatFolderData[]>) => payload
  ),
  currentFolder: createReducer<ChatFolderData | null, Action>(null).handleAction(
    setCurrentFolderAction,
    (_: ChatFolderData | null, { payload }: PayloadAction<string, ChatFolderData | null>) => payload
  ),
  createChatFolder: createReducer<ChatFolderData, Action>({
    title: "",
    position: 0
  }).handleAction(
    createChatFoldersAction,
    (_: ChatFolderData, { payload }: PayloadAction<string, ChatFolderData>) => payload
  ),
  changeChatFolder: createReducer<ChatFolderData, Action>({
    title: "",
    position: 0
  }).handleAction(
    selectChangeFolderAction,
    (_: ChatFolderData, { payload }: PayloadAction<string, ChatFolderData>) => payload
  ),
  selectChatFolders: createReducer<ChatFolderData[], Action>([]).handleAction(
    setSelectChatFoldersAction,
    (_: ChatFolderData[], { payload }: PayloadAction<string, ChatFolderData[]>) => payload
  )
});
